import { TinyMCE } from '../types';
import { useDynamicContentContext } from '../../../../../contexts';
import { getContentFromEditor } from '../utils/getContentFromEditor';

export const useContentFromEditor = (editor: TinyMCE | null) => {
  const { contentType } = useDynamicContentContext();
  return getContentFromEditor(editor, contentType);
};
